import React, {useEffect, useRef, useState} from 'react';
import SectionNavigationEntry, { iNavigationEntry } from './SectionNavigationEntry';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {faXmark, faBars} from "@fortawesome/pro-solid-svg-icons";
import {useOutsiderDetector} from "../../Hooks/useOutsiderDetector";
import {useLayout} from "../../Providers/LayoutProvider";

export interface iSectionNavigation {
	title: string;
	rounded?: boolean;
	entries: any;
	pagedEntries?: boolean;
	callback?: any;
	isGrouped?: boolean;
	isPageTitle?: boolean;
	callbackEntries?: boolean;
	addonContent?: any;
	children?: any;
}

const SectionNavigation = (props : iSectionNavigation) => {
	const [sectionOpen, setSectionOpen] = useState<boolean>(false);
	const [activeItem, setActiveItem] = useState<string>(props.title);

	const { isLarge } = useLayout();

	const menuRef: any = useRef(null);
	const menuTriggerRef: any = useRef(null);

	useOutsiderDetector(menuRef, () => sectionOpen ? setSectionOpen(false) : null);

	const UpdateActiveItem = (title: string, entry: any) => {
		if(props.callback) {
			props.callback()
		}
		
		if(entry.callback) {
			entry.callback()
		}
		
		return null;
	};

	useEffect(() => {
		setActiveItem(props.title);
	}, [props]);

	if(props.isPageTitle) {
		return (
			<nav className={`section-navigation section-navigation-horizontal ${sectionOpen ? 'open' : '' } m-0 pb-0`} ref={menuRef}>
				<div>
					<div onClick={() => setSectionOpen(!sectionOpen)} ref={menuTriggerRef}>
						<h3 className={'m-0'}>
							<FontAwesomeIcon icon={sectionOpen ? faXmark : faBars} style={{marginInlineEnd: '.75em'}} fixedWidth={true} /> {activeItem}
						</h3>
					</div>
					{props.addonContent && props.addonContent}
				</div>

				<div className={`section-navigation-entries`}>
					{props.entries.pages.map((group: any, groupIndex: number) =>
						group.data.map((entry: any, index: number) => (
							<RenderMailBoxEntry
								key={`entry${index}${groupIndex}`}
								index={index}
								entry={entry}
								updateActiveItem={() => UpdateActiveItem(entry.title, entry)}
							/>
						))
					)}
				</div>
			</nav>
		)
	}

	return (
		<nav className={`section-navigation ${sectionOpen ? 'open' : '' }`} ref={menuRef}>
			<div className={'section-navigation-header'}>
				<div className='section-navigation-title' onClick={() => setSectionOpen(!sectionOpen)} ref={menuTriggerRef}>
					<h6 className={'m-0 sub-heading'}>
						<FontAwesomeIcon icon={sectionOpen ? faXmark : faBars} style={{marginInlineEnd: '.75em'}} fixedWidth={true} /> {activeItem}
					</h6>
				</div>
				{props.addonContent && props.addonContent}
			</div>

			<div className={`section-navigation-entries`} style={{ paddingTop: !isLarge ? `${menuTriggerRef.current?.offsetHeight}px` : 0 }}>
				{props.pagedEntries ? (
					<>
						{props.entries.pages.map((group: any, groupIndex: number) =>
							group.data.map((entry: any, index: number) => (
								<RenderMailBoxEntry
									key={`entry${index}${groupIndex}`}
									index={index}
									entry={entry}
									updateActiveItem={() => UpdateActiveItem(entry.title, entry)}
								/>
							))
						)}
					</>
				) : (
					props.entries.map((entry: any, index: number) => (
						<RenderMailBoxEntry
							key={`entry${index}${index}`}
							index={index}
							entry={entry}
							updateActiveItem={() => UpdateActiveItem(entry.title, entry)}
						/>
					))
				)}

				{props.children}
			</div>
		</nav>
	);
};

export default SectionNavigation;

const RenderMailBoxEntry = ({index, updateActiveItem, entry} : {index: number, updateActiveItem: any, entry: iNavigationEntry}) => {
	return (
		<SectionNavigationEntry
			title={entry.title}
			path={entry.path}
			badgeCount={entry.badgeCount}
			icon={entry.icon}
			callback={() => updateActiveItem(entry.title, entry)}
		/>
	)
}